module.exports = __webpack_public_path__ + "static/media/night-out.2d2109bb.jpg";